// extracted by mini-css-extract-plugin
export default {"cv__title":"CV_cv__title__WBqTE","cv__item":"CV_cv__item__V53Md","cv__item__title":"CV_cv__item__title__CKs78","year":"CV_year__mWZrj"};